export default __webpack_public_path__ + "static/troy-902ffed265b8881185276604b653617f.jpg";